import Ai from 'components/ai'
import { appliesMeta } from '@/utils/functions/applies-meta'

export default appliesMeta({
    requiresAuth: true,
    template: 'chameleon'
  },
  [
    {
      path: '/ai',
      component: Ai.Index,
      name: 'ai.index'
    }
  ])
